import { createFileRoute, Outlet } from "@tanstack/react-router";
import { RouteGuard } from "@/components/auth/RouteGuard";

export const Route = createFileRoute("/_authenticated/quotation-templates")({
  component: () => (
    <RouteGuard module="quotation_templates"><Outlet /></RouteGuard>
  ),
});
